import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { SessionStore } from '../state/session.store';
import { TokenRefreshCoordinator } from '../services/token-refresh-coordinator.service';
import { isAuthFailureStatus } from '../constants/auth-failure-status';

export const refreshTokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/auth/')) {
    return next(req);
  }

  const session = inject(SessionStore);
  const coordinator = inject(TokenRefreshCoordinator);
  const router = inject(Router);

  const endSession = () => {
    session.clear();
    router.navigateByUrl('/auth/login');
  };

  if (!session.tokenPayload()) {
    return next(req);
  }

  if (session.isRefreshTokenExpired()) {
    endSession();
    return throwError(() => new Error('Session expired.'));
  }

  if (session.isAccessTokenExpiring()) {
    return coordinator.refresh().pipe(
      switchMap(() => next(req)),
      catchError(error => {
        endSession();
        return throwError(() => error);
      }),
    );
  }

  return next(req).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse) || !isAuthFailureStatus(error.status)) {
        return throwError(() => error);
      }
      return coordinator.refresh().pipe(
        switchMap(() => next(req)),
        catchError(retryError => {
          endSession();
          return throwError(() => retryError);
        }),
      );
    }),
  );
};
